import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavController, Platform} from "@ionic/angular";
import {Location} from '@angular/common';
import {Router} from "@angular/router";
import {NavigationService} from "../../service/navigation.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-back-btn',
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.scss'],
})
export class BackBtnComponent implements OnInit, OnDestroy {

  @Input() type: 'standard' | 'fab-button' = 'standard';
  @Input() title: string;
  @Input() failureNavigationPath: string[];
  @Input() preBackFn: Function;
  @Input() onBackFn: Function;

  private backButtonSub!: Subscription;

  constructor(private navCtrl: NavController,
              private platform: Platform,
              private navigationService: NavigationService) {
  }

  ngOnInit() {

    // priorità 10 è un valore "medio-alto", personalizzabile in base ai tuoi altri listener
    this.backButtonSub = this.platform.backButton.subscribeWithPriority(10, () => {
      this.onBack(); // la tua logica custom, la stessa del click
    });

  }

  onBack() {

    if(this.preBackFn){
      const valid = this.preBackFn();
      if(!valid) return;
    }

    if (this.onBackFn) {
      this.onBackFn();
    } else {
      if (this.navigationService.canGoBack()) {

        this.navCtrl.pop().then((res)=>{
          if(!res){
            this.navCtrl.navigateBack(this.failureNavigationPath);
          }
        });

      } else {
        this.navCtrl.navigateBack(this.failureNavigationPath);
      }

    }
  }

  ngOnDestroy() {
    this.backButtonSub?.unsubscribe();
  }
}
